import { Badge } from "../../components/Table";
import Edit from "./../../components/buttons/Edit";

export const clinicalScientistTableHeadData = [
  {
    accessorKey: "no",
    header: "No",
    size: 50,
  },
  { accessorKey: "uid", header: "UID", size: 50 },
  {
    accessorKey: "firstName",
    header: "First Name",
    size: 150,
  },
  {
    accessorKey: "lastName",
    header: "Last Name",
    size: 150,
  },
  {
    accessorKey: "email",
    header: "Eamil",
    size: 250,
  },
  // {
  //   accessorKey: "status",
  //   header: "Status",
  //   size: 150,
  // },
  {
    accessorKey: "action",
    header: "Action",
    size: 150,
  },
];

export const getClinicalScientistTableData = (dataSet) => {
  const tableData = dataSet?.map((item, idx) => {
    return {
      no: idx + 1,
      firstName: item?.first_name || "N/A",
      lastName: item?.last_name || "N/A",
      email: item?.email || "N/A",
      status: <Badge status={item?.status} />,
      action: <Edit user={item} />,
    };
  });
  return tableData;
};
